export default function WorkExperience({ userData, onChange, fieldErrors = {} }) {
  return (
    <div className="bg-white rounded-lg sm:rounded-xl lg:rounded-2xl shadow-sm sm:shadow-md lg:shadow-lg overflow-hidden">
      <div className="p-3 sm:p-4 md:p-5 lg:p-6 border-b border-gray-100 bg-gradient-to-r from-gray-50 to-white">
        <h3 className="text-sm sm:text-base md:text-lg lg:text-xl font-semibold text-gray-900 flex items-center gap-1 sm:gap-2">
          Work Experience
        </h3>
        <p className="mt-0.5 sm:mt-1 text-xs sm:text-sm md:text-base text-gray-600">
          Your professional background and experience
        </p>
      </div>

      <div className="p-3 sm:p-4 md:p-5 lg:p-6 space-y-3 sm:space-y-4 md:space-y-5 lg:space-y-6">
        <div className="grid grid-cols-1 gap-3 sm:gap-4 md:gap-5 lg:gap-6 md:grid-cols-2">
          {/* Company Field */}
          <div className="space-y-1 sm:space-y-2">
            <label
              htmlFor="company"
              className="block text-xs sm:text-sm md:text-base font-medium sm:font-semibold text-gray-700"
            >
              Current Company
            </label>
            <input
              type="text"
              name="company"
              id="company"
              value={userData.company}
              onChange={onChange}
              className={`block w-full px-2 py-2 sm:px-3 sm:py-2.5 md:px-4 md:py-3 text-xs sm:text-sm md:text-base border rounded-lg sm:rounded-xl focus:ring-1 sm:focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all duration-300 bg-gray-50 focus:bg-white ${
                fieldErrors.company ? 'border-red-300 focus:ring-red-500' : 'border-gray-200'
              }`}
              placeholder="Your current company"
            />
            {fieldErrors.company && (
              <p className="text-xs text-red-600 mt-1">{fieldErrors.company}</p>
            )}
          </div>

          {/* Position Field */}
          <div className="space-y-1 sm:space-y-2">
            <label
              htmlFor="position"
              className="block text-xs sm:text-sm md:text-base font-medium sm:font-semibold text-gray-700"
            >
              Position
            </label>
            <input
              type="text"
              name="position"
              id="position"
              value={userData.position}
              onChange={onChange}
              className={`block w-full px-2 py-2 sm:px-3 sm:py-2.5 md:px-4 md:py-3 text-xs sm:text-sm md:text-base border rounded-lg sm:rounded-xl focus:ring-1 sm:focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all duration-300 bg-gray-50 focus:bg-white ${
                fieldErrors.position ? 'border-red-300 focus:ring-red-500' : 'border-gray-200'
              }`}
              placeholder="Your job title"
            />
            {fieldErrors.position && (
              <p className="text-xs text-red-600 mt-1">{fieldErrors.position}</p>
            )}
          </div>

          {/* Experience Field */}
          <div className="space-y-1 sm:space-y-2">
            <label
              htmlFor="experience"
              className="block text-xs sm:text-sm md:text-base font-medium sm:font-semibold text-gray-700"
            >
              Years of Experience
            </label>
            <input
              type="text"
              name="experience"
              id="experience"
              value={userData.experience}
              onChange={onChange}
              className={`block w-full px-2 py-2 sm:px-3 sm:py-2.5 md:px-4 md:py-3 text-xs sm:text-sm md:text-base border rounded-lg sm:rounded-xl focus:ring-1 sm:focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all duration-300 bg-gray-50 focus:bg-white ${
                fieldErrors.experience ? 'border-red-300 focus:ring-red-500' : 'border-gray-200'
              }`}
              placeholder="e.g., 3+ years"
            />
            {fieldErrors.experience && (
              <p className="text-xs text-red-600 mt-1">{fieldErrors.experience}</p>
            )}
          </div>

          {/* Education Field */}
          <div className="space-y-1 sm:space-y-2">
            <label
              htmlFor="education"
              className="block text-xs sm:text-sm md:text-base font-medium sm:font-semibold text-gray-700 flex items-center gap-1 sm:gap-2"
            >
              Education
            </label>
            <input
              type="text"
              name="education"
              id="education"
              value={userData.education}
              onChange={onChange}
              className={`block w-full px-2 py-2 sm:px-3 sm:py-2.5 md:px-4 md:py-3 text-xs sm:text-sm md:text-base border rounded-lg sm:rounded-xl focus:ring-1 sm:focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all duration-300 bg-gray-50 focus:bg-white ${
                fieldErrors.education ? 'border-red-300 focus:ring-red-500' : 'border-gray-200'
              }`}
              placeholder="Your highest education"
            />
            {fieldErrors.education && (
              <p className="text-xs text-red-600 mt-1">{fieldErrors.education}</p>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}